import { render, staticRenderFns } from "./UserSessionList.vue?vue&type=template&id=4c99b771&scoped=true"
import script from "./UserSessionList.vue?vue&type=script&lang=js"
export * from "./UserSessionList.vue?vue&type=script&lang=js"
import style0 from "./UserSessionList.vue?vue&type=style&index=0&id=4c99b771&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c99b771",
  null
  
)

export default component.exports